import Vue from 'vue'
import Router from 'vue-router'
import Login from './components/Login'
import Home from './components/Home'
import Companies from './components/Companies'
import CompaniesDetail from './components/CompaniesDetail'
import CompaniesRegister from './components/CompaniesRegister'
import CallHistories from './components/CallHistories'
import CallHistoriesRegister from './components/CallHistoriesRegister'
import CallCalendars from './components/CallCalendars'
import Eight from './components/Eight'
import Graph from "./components/Graph"

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'ログイン画面',
        isPublic: true,
      },
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      redirect: {name: 'Companies'},
      children: [
        {
          path: '/companies',
          name: 'Companies',
          component: Companies,
          meta: {
            title: '会社一覧画面',
          },
        },
        {
          path: '/companies/:company_id/detail',
          name: 'CompaniesDetail',
          component: CompaniesDetail,
          meta: {
            title: '会社詳細画面',
          },
        },
        {
          path: '/companies/:company_id/register',
          name: 'CompaniesRegister',
          component: CompaniesRegister,
          meta: {
            title: '会社登録画面',
          },
        },
        {
          path: '/call-histories',
          name: 'CallHistories',
          component: CallHistories,
          meta: {
            title: '通話履歴一覧画面',
          },
        },
        {
          path: '/call-histories/:call_id/register/:company_id',
          name: 'CallHistoriesRegister',
          component: CallHistoriesRegister,
          meta: {
            title: '通話履歴登録画面',
          },
        },
        {
          path: '/call-calendars/',
          name: 'CallCalendars',
          component: CallCalendars,
          meta: {
            title: '通話件数カレンダー',
          },
        },
        {
          path: '/graphs/',
          name: 'Graph',
          component: Graph,
          meta: {
            title: 'グラフ',
          },
        },
        {
          path: '/eight/',
          name: 'Eight',
          component: Eight,
          meta: {
            title: 'Eight連携',
          },
        },
      ],
    },
  ],
})

router.beforeEach((to, from, next) => {
  const loggedIn = Number(localStorage.getItem('loggedIn'))
  //公開ページではなくかつログイン済みでない場合にログイン画面にリダイレクト
  if (to.matched.some(record => !record.meta.isPublic) && !loggedIn) {
    next({path: '/login', query: {redirect: to.fullPath}})
  } else {
    next()
  }
})

export default router
